import { CompatClient, Stomp } from '@stomp/stompjs';
import { EventEmitter } from './EventEmitter';
import { getConnectionData } from '../helpers/url';

export class StompConnector {
    static stompClient: CompatClient;
    static gameId: string;
    static playerSessionId: string;
    static accountType: string;
    static connectorUrl: string;
    static gameSessionId: string;
    static playerName: string;

    static init = async () => {
        console.debug('Initialising GDK...');

        const connectionData = getConnectionData();

        if (connectionData) {
            await StompConnector.connect();

            return true;
        } else {
            console.error('Unable to initialise connection, error found in connection data');
        }
        return false;
    };

    static connectStomp() {
        console.debug(`Connecting to STOMP at ${this.connectorUrl}`);

        const connectCallback = () => {
            this.stompClient.subscribe(`/topic/${this.gameId}`, (frame) => {
                const event = JSON.parse(frame.body);

                EventEmitter.emit(event.type, event);
            });

            this.stompClient.subscribe('/user/queue/game', (frame) => {
                const event = JSON.parse(frame.body);
                if (event.type === 'common:connection') {
                    this.gameSessionId = event.gameSessionId;
                    this.playerName = event.goosicornUsername;
                }

                if (event.events) {
                    event.events.forEach((subEventString: string) => {
                        const subEvent = JSON.parse(subEventString);
                        EventEmitter.emit(subEvent.type, subEvent);
                        console.debug(subEvent);
                    });
                } else {
                    EventEmitter.emit(event.type, event);
                }
            });

            this.performActivation();
        };

        this.stompClient.debug = () => { };
        this.stompClient.connect(
            {}, // headers
            connectCallback,
            (error: string) => {
                console.error(`Error: ${error}`);
            },
            (message: { type: string }) => {
                if (message && message.type === 'close') {
                    EventEmitter.emit('gdk:close', 'closure');
                }
            },
        );
    }

    static performActivation() {
        StompConnector.stompClient.send(
            '/app/activation',
            {},
            JSON.stringify({
                gameId: this.gameId,
                playerSessionId: this.playerSessionId,
                accountType: this.accountType,
            }),
        );
    }

    static connect() {
        const params = new URLSearchParams(window.location.search);

        // Retrieve individual parameters
        this.connectorUrl = params.get('server') || '';

        // TODO: remove this after Tom fixes the issue with missing params in url
        if (!this.connectorUrl.includes('/multigame') && this.connectorUrl.includes('/game')) {
            this.connectorUrl = this.connectorUrl.replace('/game', '/multigame');
        }

        this.gameId = params.get('gameId') || '';
        this.playerSessionId = params.get('playerSessionId') || '';
        this.accountType = params.get('accountType') || '';

        this.stompClient = Stomp.client(this.connectorUrl);

        this.connectStomp();
    }

    static performAction(amount: number, selectedRacer: string, raceId: string) {
        if (this.stompClient) {
            const actionBase = JSON.stringify({
                type: 'horses:bet',
                bet: amount,
                selection: selectedRacer,
                engineRoundId: raceId,
                gameSessionId: this.gameSessionId,
            });
            const action = JSON.stringify({
                gameSessionId: this.gameSessionId,
                gameAction: actionBase,
            });
            console.log('Publishing: ' + action);
            this.stompClient.send('/app/action', {}, action);
        }
    }

    static getPlayername() {
        return this.playerName;
    }

    static sendEmoji(emoji: string) {
        if (this.stompClient) {
            const emojiMessage = JSON.stringify({
                gameId: this.gameId,
                playerSessionId: this.playerSessionId,
                emoji,
            });
            console.log('Publishing: ' + emojiMessage);
            this.stompClient.send('/app/emoji', {}, emojiMessage);
        }
    }

    static getGameId() {
        return this.gameId;
    }
}

export default StompConnector;

// sealed interface HorsesEngineActions {

//     data class PlaceBetAction(val engineRoundId: String, val bet: Long, val selection: HorseName) : HorsesEngineActions, GameAction {
//         companion object {
//             const val ACTION_NAME: String = "$GAME_MESSAGE_PREFIX:bet"
//         }

//         override fun actionName(): String {
//             return ACTION_NAME
//         }
//     }
// }

// data class PublicWinUpdate(
//     val currency: String,
//     val amount: Long,
//     val gameAction: String,
//     var goosicornUsername: String?,
// ) : AbstractConnectorMessage("common", "public-win")

// data class PublicBetUpdate(
//     val currency: String,
//     val amount: Long,
//     val gameAction: String,
//     var goosicornUsername: String?,
// ) : AbstractConnectorMessage("common", "public-bet")

// That 2 events are the ones that inform you about the people placing bets and the people winning on that bets

// Other events:
// data class AvailableActionsEvent(
//     val actions: List<String>,
//     val gamePhase: HorseEnginePhase,
//     val engineRoundId: String,
//     var connecting: Boolean = false) : HorsesEngineEvents, GameEvent("$GAME_MESSAGE_PREFIX:available-actions")[11:59 AM]    data class ShowEvent(
//     val engineRoundId: String,
//     val currentState: HorseEnginePhase,
//     val result: List<Horse>?,
//     val lastResults: List<Horse>,
//     val defaultBet: Long) : HorsesEngineEvents, GameEvent("$GAME_MESSAGE_PREFIX:show-event")[11:59 AM]const val GAME_MESSAGE_PREFIX: String = "horses"
